export default __webpack_public_path__ + "static/media/16.7ac6d6b7.png";